import {Factory} from './Factory'
import Menu from '../EditorComponents/Alert/Menu'

export class AlertFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('alert'),
      iconContainerId: this.id('alert-icon-container'),
      iconId: this.id('alert-icon'),
      textId: this.id('alert-text'),
      slug: 'editor-alert',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses:{
        phone: [],
        tablet: [],
        desktop:[]
      },
      name: 'Alert',
    }
  }

  properties() {
    return {
      content: [
        {key: 'has-icon', component:'ContentToggle', text:'has an Icon', property:'hasIcon'},
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'has-title', component:'ContentToggle', text:'has a Title', property:'hasTitle'},
        {key: 'is-closable', component:'ContentToggle', text:'is closable', property:'isClosable'}
      ],
      styles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color']},
        {key: 'border', component:'BorderProperty'},
        {key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
        {key: 'margin', component:'MarginProperty'},
      ],
      iconStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class: 'iconContainerClasses', styles:'iconContainerStyles'},
        {key: 'border', component:'BorderProperty', class:'iconContainerClasses', styles: 'iconContainerStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'iconContainerClasses'},
        {key: 'text-color', component:'TextColorProperty', styles: 'iconStyles'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
